import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  pointer-events: none;
  background-color: rgba(255, 255, 255, 0.95); // slightly brighter
  border: 1px solid #A54DD7;
  border-radius: 4px;
  padding: 8px 12px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  font-family: 'Lucida Grande', 'Lucida Sans Unicode', Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #333333;
  z-index: 9999;
  transition: opacity 0.2s;
  white-space: nowrap;
  transform: translate(15px, 15px);
`;

export const Title = styled.span`
  display: block;
  font-size: 10px;
  margin-bottom: 5px;
  color: #333333;
`;

export const Marker = styled.span`
  color: #A54DD7;
  margin-right: 5px;
`;